import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { TandemLink } from 'library';

export default function WorkerMenu({
    isMenuOpen,
    handleMenuClose,
    anchorRef,
}: {
    isMenuOpen: boolean;
    handleMenuClose: () => void;
    anchorRef: React.RefObject<HTMLDivElement> | null;
}) {
    return (
        <Menu
            anchorEl={anchorRef?.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{
                borderRadius: 18,
            }}
        >
            <MenuItem>
                <TandemLink to="/workers" onClick={handleMenuClose}>
                    How It Works
                </TandemLink>
            </MenuItem>
            <MenuItem>
                <TandemLink to="/listings" onClick={handleMenuClose}>
                    Available Jobs
                </TandemLink>
            </MenuItem>
        </Menu>
    );
}
